import { Input } from "../ui/input";

const DAY_OPTS = [7, 3, 2, 1, 0];
export const EMPTY_TIMER = { deadline: "", label: "", alert_days: [3, 1, 0], phones: [], notify_creator: true, notify_holder: true };

export const LegalTimerFields = ({ t, onChange }) => {
  const set = (k, v) => onChange({ ...t, [k]: v });
  const toggle = (d) => set("alert_days", t.alert_days.includes(d) ? t.alert_days.filter((x) => x !== d) : [...t.alert_days, d]);
  const [dPart, tPart = ""] = (t.deadline || "").split("T");
  const [hh = "", mm = ""] = tPart.split(":");
  const setDT = (dd, h, m) => set("deadline", dd ? `${dd}T${String(h || "09").padStart(2, "0")}:${String(m || "00").padStart(2, "0")}` : "");
  const sel = "mt-0.5 h-9 rounded-md border border-slate-200 bg-white px-2 text-sm";
  return (
    <div className="space-y-2" data-testid="legal-timer-fields">
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        <label className="text-[11px] font-semibold text-slate-500">التاريخ
          <Input type="date" value={dPart || ""} onChange={(e) => setDT(e.target.value, hh, mm)} className="mt-0.5 h-9" data-testid="legal-timer-date" /></label>
        <label className="text-[11px] font-semibold text-slate-500">الساعة
          <select value={hh || "09"} onChange={(e) => setDT(dPart, e.target.value, mm)} disabled={!dPart} className={`${sel} block w-full`} data-testid="legal-timer-hour">
            {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0")).map((h) => <option key={h} value={h}>{h}:00 {Number(h) < 12 ? "ص" : "م"}</option>)}
          </select></label>
        <label className="text-[11px] font-semibold text-slate-500">الدقيقة
          <select value={mm || "00"} onChange={(e) => setDT(dPart, hh, e.target.value)} disabled={!dPart} className={`${sel} block w-full`} data-testid="legal-timer-minute">
            {Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0")).map((m) => <option key={m} value={m}>{m}</option>)}
          </select></label>
        <label className="text-[11px] font-semibold text-slate-500">وصف الموعد
          <Input value={t.label} onChange={(e) => set("label", e.target.value)} placeholder="مثال: موعد الجلسة" className="mt-0.5 h-9" data-testid="legal-timer-label" /></label>
      </div>
      <p className="text-[11px] text-slate-400">لن يُحفظ شيء حتى تضغط زر الحفظ.</p>
      <div>
        <p className="text-[11px] font-semibold text-slate-500">إرسال تنبيه واتساب قبل الموعد بـ</p>
        <div className="mt-1 flex flex-wrap gap-1.5">
          {DAY_OPTS.map((d) => (
            <button key={d} type="button" onClick={() => toggle(d)} data-testid={`legal-timer-day-${d}`}
              className={`rounded-full border px-2.5 py-1 text-[11px] font-bold transition-colors ${t.alert_days.includes(d) ? "border-emerald-600 bg-emerald-600 text-white" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}>
              {d === 0 ? "عند انتهاء المؤقت" : `${d} ${d > 2 ? "أيام" : "يوم"}`}
            </button>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap gap-3 text-[11px] text-slate-600">
        <label className="flex items-center gap-1"><input type="checkbox" checked={t.notify_creator} onChange={(e) => set("notify_creator", e.target.checked)} data-testid="legal-timer-creator" /> فاتح القضية</label>
        <label className="flex items-center gap-1"><input type="checkbox" checked={t.notify_holder} onChange={(e) => set("notify_holder", e.target.checked)} data-testid="legal-timer-holder" /> من لديه القضية حالياً</label>
      </div>
      <Input dir="ltr" value={(t.phones || []).join(", ")} onChange={(e) => set("phones", e.target.value.split(/[,،\s]+/).filter(Boolean))} placeholder="أرقام إضافية: 05xxxxxxxx, 05xxxxxxxx" className="h-9" data-testid="legal-timer-phones" />
    </div>
  );
};
